import { render, staticRenderFns } from "./GestioneLayout.vue?vue&type=template&id=019ad28e&"
import script from "./GestioneLayout.vue?vue&type=script&lang=js&"
export * from "./GestioneLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports